import { Download } from "feather-icons-react/build/IconComponents"
import React, { useState, useEffect, useRef} from "react"
import { Mail } from "react-feather"
import { Link } from "react-router-dom"
import { Select, Spin, DatePicker, message } from "antd"
import { SendOutlined } from "@ant-design/icons";
import {sendIndividualSMS } from '../../service/smsService'
import dayjs from "dayjs"
import { ArrowLeft } from "lucide-react"
import { getUserPayroll, sendIndividualPayslip } from "../../service/payrollservice"
// import {getEmployeeByUserId} from "../../service/employeeService";
// import {getUserById} from '../../service/userService';
import jsPDF from "jspdf"
// import { notification} from "antd";

const { Option } = Select

const EmployeePayslip = () => {
  const currentYear = dayjs().year()
  const currentMonth = new Date().getMonth()
  const payslipRef = useRef(null)

  const [selectedYear, setSelectedYear] = useState(currentYear)
  const [selectedMonth, setSelectedMonth] = useState(currentMonth + 1)
  const [loading, setLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [payrollId, setPayrollId] = useState(null)

  const [employeeData, setEmployeeData] = useState({
    account_holder: "OKI INTERNATIONAL SCHOOL",
    location: "WATTALA",
    month: "March 2024",
    epf_number: "",
    branch: "",
    name: "",
    nic: "",
    bank: "N/A",
    email:"",
    account_number: "",
    phone_number:"",
  })

  const [salaryData, setSalaryData] = useState({
    basic: 0,
    budgetAllowance1000: "-",
    budgetAllowance2500: "-",
    totalBasic: 0,
    otherAllowances: "-",
    ot: "-",
    grossPay: 0,
    noPay: 0,
    epf8: 0,
    wsLsContribution: 0,
    salaryAdvance: 0,
    staffLoan: 0,
    festivalAdvance: 0,
    otherDeduction: 0,
    deductions: "-",
    payeTax: 0,
    totalDeductions: 0,
    netSalary: 0,
    travellingReimbursement: 0,
    epf12: "-",
    epf20: "-",
    etf3: "-",
  })

  const [fields, setFields] = useState([])
  const [isCustomizing, setIsCustomizing] = useState(false)
  const [availableFields] = useState([
    { id: "basic", label: "Basic" },
    { id: "budgetAllowance1000", label: "Budget Allowance Rs.1000" },
    { id: "budgetAllowance2500", label: "Budget Allowance Rs.2500" },
    { id: "totalBasic", label: "Total Basic" },
    { id: "otherAllowances", label: "Other Allowances" },
    { id: "ot", label: "OT" },
    { id: "grossPay", label: "Gross Pay" },
    { id: "noPay", label: "Less: No Pay" },
    { id: "epf8", label: "08% EPF" },
    { id: "wsLsContribution", label: "WS & LS Contribution" },
    { id: "salaryAdvance", label: "Salary advance" },
    { id: "staffLoan", label: "Staff loan" },
    { id: "festivalAdvance", label: "Festival advance" },
    { id: "otherDeduction", label: "Other" },
    { id: "deductions", label: "Deductions" },
    { id: "payeTax", label: "Paye Tax" },
    { id: "totalDeductions", label: "Total Deductions" },
    { id: "netSalary", label: "Net Salary" },
    { id: "travellingReimbursement", label: "Travelling & attendance reimbursement" },
    { id: "incentive", label: "Incentive" },
    { id: "totalPay", label: "Banked Salary & Trv. Claim to CB" },
    { id: "epf12", label: "12% EPF" },
    { id: "epf20", label: "20% EPF" },
    { id: "etf3", label: "03% ETF" },
  ])

  useEffect(() => {
    const initialFields = availableFields.map((field) => ({
      id: field.id,
      label: field.label,
      value: salaryData[field.id] || 0,
      customClass: "",
    }))
    setFields(initialFields)
  }, [])

  const fetchPayrollData = async () => {
    setLoading(true)
    try {
      const response = await getUserPayroll(selectedMonth, selectedYear)
      console.log("Backend Response:", response)

      if (response && response.payrollRecord && response.employee) {
        const { payrollRecord, employee } = response
        setPayrollId(payrollRecord._id)

        setEmployeeData({
          schoolName: "OKI INTERNATIONAL SCHOOL",
          location: "WATTALA",
          month: `${getMonthName(selectedMonth)} ${selectedYear}`,
          epf_number: employee.epf_number || "",
          branch: employee.branch || "",
          name: `${employee.first_name || ""} ${employee.last_name || ""}`,
          nic: employee.nic || "",
          bank: employee.bank || "N/A",
          email:employee.email || "",
          phone_number:employee.phone_number || "",
          account_number: employee.account_number || "",
          account_holder: `${employee.first_name || ""} ${employee.last_name || ""}`,
        })

        const allAllowances = Array.isArray(payrollRecord.allowances) ? payrollRecord.allowances : [];
        const matchers = [
          { key: 'other', label: 'Other Allowances', test: (n) => /1\]/i.test(n) || /other\s+allowances?/i.test(n) },
          { key: 'travelling', label: 'Travelling Allowance', test: (n) => /2\]/i.test(n) || (/travell?ing/i.test(n) && !/&/i.test(n)) },
          { key: 'attendance', label: 'Attendance Reimbursement', test: (n) => /3\]/i.test(n) || /attendance\s+reimbursement/i.test(n) },
          { key: 'fixed', label: 'Fixed Allowance', test: (n) => /4\]/i.test(n) || /fixed\s+allowance/i.test(n) || /rs\.?\s*1000\s+or/i.test(n) }
        ];

        const matchedIds = new Set();
        const reimbursementItems = [];
        let calculatedTravellingTotal = 0;

        matchers.forEach(({ label, test }) => {
          const found = allAllowances.find(a => {
            const name = (a.allowanceType?.name || a.name || '').trim();
            const id = a._id?.toString() || name;
            return !matchedIds.has(id) && test(name);
          });
          if (found) {
            matchedIds.add(found._id?.toString() || (found.allowanceType?.name || found.name));
            const amt = parseFloat(found.amount || 0);
            calculatedTravellingTotal += amt;
            reimbursementItems.push({
              name: found.allowanceType?.name || label,
              amount: amt,
              showPaySlip: found.allowanceType?.showPaySlip ?? found.showPaySlip ?? true
            });
          }
        });

        const directMatch = allAllowances.find(a => {
          const name = (a.allowanceType?.name || a.name || '').trim();
          const id = a._id?.toString() || name;
          return !matchedIds.has(id) && /travell?ing\s*&\s*attendance\s*reimbursement/i.test(name);
        });
        if (directMatch) {
          calculatedTravellingTotal += parseFloat(directMatch.amount || 0);
        }

        const finalTravellingReimbursement = calculatedTravellingTotal > 0
          ? calculatedTravellingTotal
          : (payrollRecord.allowances?.find(value => value.allowanceType?.name === "Travelling & attendance reimbursement")?.amount || 0);

        const newSalaryData = {
          basic: payrollRecord.basicSalary || 0,
          budgetAllowance1000: payrollRecord.allowance1000 || "-",
          budgetAllowance2500: payrollRecord.allowance2500 || "-",
          totalBasic: payrollRecord.totalBasic || 0,
          otherAllowances: payrollRecord.otherAllowances || "-",
          ot: payrollRecord.overtimePay || "-",
          grossPay: payrollRecord.grossPay || 0,
          noPay: payrollRecord.totalNoPay || 0,
          epf8: payrollRecord.epf || 0,
          wsLsContribution: payrollRecord.wsLsContribution || 0,
          salaryAdvance: payrollRecord.salaryAdvance || 0,
          staffLoan: payrollRecord.staffLoan || 0,
          festivalAdvance: payrollRecord.festivalAdvance || 0,
          otherDeduction: payrollRecord.otherDeduction || 0,
          deductions: payrollRecord.totalDeductions || "-",
          payeTax: payrollRecord.payeTax || 0,
          totalDeductions: payrollRecord.sumOfAllDeductions || 0,
          netSalary: payrollRecord.netPay || 0,
          travellingReimbursement: finalTravellingReimbursement,
          incentive: payrollRecord.allowances?.find(value => value.allowanceType.name === "Incentive")?.amount || 0,
          totalPay: payrollRecord.totalPay,
          epf12: payrollRecord.epf12 || 0,
          epf20: payrollRecord.epf20 || 0,
          etf3: payrollRecord.etf3 || 0,
          reimbursementItems: reimbursementItems,
          allowances: allAllowances,
        }

        setSalaryData(newSalaryData)

        const baseFields = availableFields.map((field) => ({
          id: field.id,
          label: field.label,
          value: newSalaryData[field.id] || 0,
          customClass: "",
        }));

        const travellingIndex = baseFields.findIndex(f => f.id === "travellingReimbursement");
        const extraItems = reimbursementItems
          .filter(item => item.showPaySlip && item.amount > 0)
          .map(item => ({
            id: `reimburse_${item.name}`,
            label: item.name,
            value: item.amount,
            customClass: "",
          }));

        if (travellingIndex !== -1 && extraItems.length > 0) {
          baseFields.splice(travellingIndex, 0, ...extraItems);
        }

        setFields(baseFields);

        message.success("Payroll data loaded successfully")
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error)
      message.error("Failed to load payroll data. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchPayrollData()
  }, [selectedMonth, selectedYear])
  const generatePayslipPDF = () => {
    setDownloadLoading(true)
    const record = salaryData;
    const empData = employeeData;
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 15;
    const contentWidth = pageWidth - margin * 2;

    // Formatting Helper
    const formatCurrency = (amount) => {
      const num = parseFloat(amount);
      if (isNaN(num) || num === null || num === undefined) return "0.00";
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    // Header Section
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("OKI INTERNATIONAL SCHOOL", pageWidth / 2, 20, { align: "center" });

    doc.setFontSize(12);
    doc.setFont("helvetica", "normal");
    doc.text("WATTALA", pageWidth / 2, 28, { align: "center" });

    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    // Use the payroll record's actual month and year instead of the selected dropdown values
    const payrollMonth = record.month || selectedMonth;
    const payrollYear = record.year || selectedYear;
    const monthName = getMonthName(payrollMonth);
    doc.text(`Salary for the month of ${monthName} ${payrollYear}`, margin, 38);

    // Employee Details Section
    doc.autoTable({
      startY: 42,
      margin: { left: margin, right: margin },
      theme: "plain",
      styles: { fontSize: 9, cellPadding: 1 },
      columnStyles: { 0: { fontStyle: "bold", cellWidth: 30 } },
      body: [
        [
          "EPF NUMBER:",
          empData.epf_number || "-"
        ],
        [
          "Branch:",
          empData.branch || "OKI - Wattala"
        ],
        [
          "Name:",
          empData.name || `${empData.first_name || ""} ${empData.last_name || ""}`
        ],
        [
          "ID Number:",
          empData.nic || "-"
        ]
      ],
    });

    let currentY = doc.lastAutoTable.finalY + 5;

    // Table Common Styles
    const tableStyles = {
      theme: "plain",
      styles: { fontSize: 9, cellPadding: 1.5, overflow: 'hidden' },
      columnStyles: {
        0: { halign: 'left', cellWidth: contentWidth * 0.6 },
        1: { halign: 'right', cellWidth: contentWidth * 0.4 }
      },
      margin: { left: margin, right: margin },
    };

    const earningsBody = [
      ["Basic Salary", formatCurrency(record.basic)],
      ["Budget Allowance (1000)", parseFloat(record.allowance1000) > 0 ? formatCurrency(record.allowance1000) : "0.00"],
      ["Budget Allowance (2500)", parseFloat(record.allowance2500) > 0 ? formatCurrency(record.allowance2500) : "0.00"],
    ];


    // if (record.allowances && record.allowances.length > 0) {
    //      record.allowances.forEach(allow => {
    //          earningsBody.push([allow.name, formatCurrency(allow.amount)]);
    //      });
    // }
    //
    // console.log("Record Allowances",earningsBody)


    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: earningsBody,
    });
    currentY = doc.lastAutoTable.finalY;

    // 3. TOTAL BASIC
    // Using simple line for separation
    doc.setDrawColor(200, 200, 200);
    doc.line(margin, currentY, pageWidth - margin, currentY);

    doc.autoTable({
      startY: currentY + 1,
      ...tableStyles,
      body: [
        ["Total Basic", formatCurrency(record.totalBasic)]
      ],
      didParseCell: (data) => {
        data.cell.styles.fontStyle = 'bold';
      }
    });
    currentY = doc.lastAutoTable.finalY;

    // 4. TOTAL EARNINGS (Gross Pay) include OT etc
    const otherEarningsBody = [];
    // Always show OT
    otherEarningsBody.push(["OT", formatCurrency(record.overtimePay || 0)]);

    if (otherEarningsBody.length > 0) {
      doc.autoTable({
        startY: currentY,
        ...tableStyles,
        body: otherEarningsBody
      });
      currentY = doc.lastAutoTable.finalY;
    }


    doc.setDrawColor(0, 0, 0); // darker line
    doc.line(margin, currentY, pageWidth - margin, currentY);

    doc.autoTable({
      startY: currentY + 1,
      ...tableStyles,
      body: [
        ["Gross pay", formatCurrency(record.grossPay)]
      ],
      didParseCell: (data) => {
        data.cell.styles.fontStyle = 'bold';
      }
    });
    currentY = doc.lastAutoTable.finalY + 5;

    const deductionsBody = [];
    deductionsBody.push(["Less : No Pay", formatCurrency(record.totalNoPay || 0)]);
    deductionsBody.push(["08% EPF", formatCurrency(record.epf8)]);
    deductionsBody.push(["WS & LS Contribution", formatCurrency(record.wsLsContribution || 0)]);
    deductionsBody.push(["Salary advance", formatCurrency(record.salaryAdvance || 0)]);
    deductionsBody.push(["Staff loan", formatCurrency(record.staffLoan || 0)]);
    deductionsBody.push(["Festival advance", formatCurrency(record.festivalAdvance || 0)]);
    deductionsBody.push(["Other", formatCurrency(record.otherDeduction || 0)]);
    deductionsBody.push(["Payee tax", formatCurrency(record.payeTax || 0)]);
    console.log("Payee tax",record.payeTax)
    // Add other dynamic deductions
    if(record.otherDeductions && Array.isArray(record.otherDeductions)) {
      record.otherDeductions.forEach(ded => {
        const amount = ded.paymentType === "recurring" ? ded.installement : ded.amount;
        deductionsBody.push([ded.description || "Other Deduction", formatCurrency(amount)]);
      });
    }

    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: deductionsBody,
    });
    currentY = doc.lastAutoTable.finalY;

    // 6. TOTAL DEDUCTIONS
    doc.line(margin, currentY, pageWidth - margin, currentY);
    doc.autoTable({
      startY: currentY + 1,
      ...tableStyles,
      body: [
        ["TOTAL DEDUCTIONS", formatCurrency(record.totalDeductions)]
      ],
      didParseCell: (data) => {
        data.cell.styles.fontStyle = 'bold';
      }
    });
    currentY = doc.lastAutoTable.finalY + 5;

    // 7. NET SALARY PAYABLE
    // Double Border for Emphasis
    doc.setDrawColor(0, 0, 0);
    doc.setLineWidth(0.5);
    // Top line
    doc.line(margin, currentY, pageWidth - margin, currentY);
    // Button line will be handled by next content or manual draw

    // Calculate values locally just for verification or display consistency if needed, but primarily use record
    // const calculatedNet = parseFloat(record.grossPay) - parseFloat(record.sumOfAllDeductions);

    doc.autoTable({
      startY: currentY + 1,
      ...tableStyles,
      styles: { fontSize: 11, cellPadding: 3 },
      body: [
        ["NET SALARY", formatCurrency(record.netSalary)]
      ],
      didParseCell: (data) => {
        data.cell.styles.fontStyle = 'bold';
        if(data.column.index === 1) {
          //  data.cell.styles.textColor = [0, 0, 0];
        }
      }
    });
    currentY = doc.lastAutoTable.finalY;

    doc.line(margin, currentY, pageWidth - margin, currentY);
    doc.setLineWidth(0.1); // reset
    currentY += 6;

    // Add Travelling & attendance reimbursement component breakdown and calculated total
    const reimbursementBody = [];
    if (record.reimbursementItems && Array.isArray(record.reimbursementItems)) {
      record.reimbursementItems.forEach(item => {
        if (item.showPaySlip && item.amount > 0) {
          reimbursementBody.push([item.name, formatCurrency(item.amount)]);
        }
      });
    }
    reimbursementBody.push(["Travelling & attendance reimbursement", formatCurrency(record.travellingReimbursement) || 0]);

    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: reimbursementBody
    });
    currentY = doc.lastAutoTable.finalY + 3;
    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: [
        ["Incentive", formatCurrency(record.incentive) || 0]
      ]
    });
    currentY = doc.lastAutoTable.finalY + 3;
    console.log("Travelling & attendance reimbursement",record.allowances?.find(value => value.allowanceType.name === "Travelling & attendance reimbursement")?.amount)
    // Banked Salary & Trv. Claim section
    const baseNetPay = parseFloat(record.netSalary || record.netPay || 0);
    const incentiveAmt = parseFloat(record.incentive || 0);
    const totalBanked = parseFloat(record.totalPay || 0) > baseNetPay
      ? parseFloat(record.totalPay || 0)
      : (baseNetPay + parseFloat(record.travellingReimbursement || 0) + incentiveAmt);
    if(totalBanked > 0) {
      const bankName = record.bank_name || record.bank || 'NDB';
      doc.autoTable({
        startY: currentY,
        theme: "plain",
        styles: { fontSize: 9, cellPadding: 1.5, overflow: 'linebreak' },
        columnStyles: {
          0: { halign: 'left', cellWidth: contentWidth * 0.65 },
          1: { halign: 'right', cellWidth: contentWidth * 0.35 }
        },
        margin: { left: margin, right: margin },
        body: [
          [`Banked Salary & Trv. Claim to ${bankName}`, formatCurrency(totalBanked)]
        ]
      });
      currentY = doc.lastAutoTable.finalY + 5;
    }

    // Received Salary & Traveling reimbursement section
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Received Salary & Traveling reimbursement ........................................................", margin, currentY);
    currentY += 8;

    const employerBody = [
      ["12% EPF", formatCurrency(record.epf12)],
      ["20% EPF", formatCurrency(record.epf20 || 0)],
      ["03% ETF", formatCurrency(record.etf3)]
    ];

    doc.autoTable({
      startY: currentY,
      ...tableStyles,
      body: employerBody
    });

    // Footer Note
    const finalY = doc.lastAutoTable.finalY + 10;
    doc.setFontSize(8);
    doc.setFont("helvetica", "italic");
    doc.text("This is a system generated payslip.", pageWidth / 2, finalY, { align: "center" });

    // Save
    const blob = new Blob([doc.output("arraybuffer")], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Payslip_${empData.epf_number}_${monthName}_${payrollYear}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    setDownloadLoading(false)
  };

  const getMonthName = (monthNumber) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ]
    return months[monthNumber - 1]
  }

  const formatCurrency = (value) => {
    if (value === "-" || value == null || value === "") return value

    const number = Number(value)
    if (isNaN(number)) return value

    return number.toLocaleString("en-LK", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }

  const startCustomizing = () => {
    setIsCustomizing(true)
  }

  const saveCustomization = () => {
    setIsCustomizing(false)
  }

  const moveFieldUp = (index) => {
    if (index === 0) return
    const newFields = [...fields]
    ;[newFields[index], newFields[index - 1]] = [newFields[index - 1], newFields[index]]
    setFields(newFields)
  }

  const moveFieldDown = (index) => {
    if (index === fields.length - 1) return
    const newFields = [...fields]
    ;[newFields[index], newFields[index + 1]] = [newFields[index + 1], newFields[index]]
    setFields(newFields)
  }

  const updateFieldLabel = (index, newLabel) => {
    const newFields = [...fields]
    newFields[index].label = newLabel
    setFields(newFields)
  }
  const handleSendIndividualSMS = async () => {
    try {

      const phoneNumber = localStorage.getItem("phone_number") || employeeData.phone_number ;
      const message = `Dear ${employeeData.name}, your payslip for this month is ready. You can now download it from the employee portal.`;
      
      await sendIndividualSMS(phoneNumber, message);
      message.success('SMS notification sent successfully');
    } catch (error) {
      console.error('Error sending individual SMS:', error);
      console.error('Failed to send SMS notification');
    }
  };
  const updateFieldClass = (index, newClass) => {
    const newFields = [...fields]
    newFields[index].customClass = newClass
    setFields(newFields)
  }

  const updateEmployeeData = (field, value) => {
    setEmployeeData({
      ...employeeData,
      [field]: value,
    })
  }

  const updateSalaryData = (field, value) => {
    const newSalaryData = {
      ...salaryData,
      [field]: value,
    }

    const newFields = fields.map((f) => {
      if (f.id === field) {
        return { ...f, value: value }
      }
      return f
    })

    setSalaryData(newSalaryData)
    setFields(newFields)
  }

  const handleMonthChange = (value) => {
    setSelectedMonth(value)
  }

  const handleYearChange = (date, dateString) => {
    setSelectedYear(dateString)
  }

  // const handleGeneratePayroll = () => {
  //   fetchPayrollData()
  // }


  const sendPayslipEmailHandler = async (e) => {
    e.preventDefault();
    if (!payrollId || loading) return;
  
    try {
      setLoading(true);
      console.log("Sending payslip email to:", employeeData.email);
      const result = await sendIndividualPayslip(payrollId);
      if (result.success) {
        message.success("Payslip sent successfully to your email!");
      } else {
        message.error(result.message || "Failed to send payslip");
      }
    } catch (error) {
      console.error("Error sending payslip email:", error);
      message.error("Failed to send payslip email. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="header-leave-container ">
                <div>
                  <ArrowLeft size={32} />
                </div>

                <div className="page-title">
                  <h4>Employee Payslip</h4>
                  <h6>Get your Payslip</h6>
                </div>
              </div>
            </div>
            <div className="wordset">
              <ul>
                <div className="page-btn" style={{ width: 150, height: 35 }}>
                  <Link to="#" className="btn btn-added-grid me-2" onClick={sendPayslipEmailHandler}>
                    <Mail className="me-2" />
                    Send Email
                  </Link>{" "}
                </div>

                <div className="page-btn" style={{ width: 150, height: 35, color: "red", display:"none" }}>
                  
                  <Link to="#" className="btn btn-added-grid"     style={{backgroundColor:'gray', color:'white'}}      onClick={handleSendIndividualSMS}
                  >
                              <SendOutlined style={{marginRight:"5px"}}/>
                  
                    Send SMS
                  </Link>
                </div>
             
                <div className="page-btn" style={{ width: 150, height: 35 }}>
                  <button
                    onClick={generatePayslipPDF}
                    className="btn btn-added-download"
                    disabled={loading || downloadLoading}
                  >
                    {downloadLoading ? (
                      <>
                        <Spin size="small" /> <span>Downloading...</span>
                      </>
                    ) : (
                      <>
                        <Download className="me-2" />
                        Download
                      </>
                    )}
                  </button>
                </div>

         
              </ul>
            </div>
            <div className="wordset"                     style={{ display:"none" }}
            >
              <ul>
                {!isCustomizing ? (
                  <button
                    className="page-btn"
                    onClick={startCustomizing}
                    style={{ width: 100, height: 35, color: "white", borderRadius: "5px", backgroundColor: "black",display:"none" }}
                  >
                    Edit Template
                  </button>
                ) : (
                  <button
                    className="page-btn"
                    onClick={saveCustomization}
                    style={{ width: 100, height: 35, color: "white", borderRadius: "5px", backgroundColor: "green" }}
                  >
                    Done
                  </button>
                )}
              </ul>
            </div>
          </div>
          <div className="salary-slip-container">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                marginBottom: "10px",
              }}
            >
              <div>
                <Select value={selectedMonth} style={{ width: "100%" }} size={"large"} onChange={handleMonthChange}>
                  <Option value={1}>January</Option>
                  <Option value={2}>February</Option>
                  <Option value={3}>March</Option>
                  <Option value={4}>April</Option>
                  <Option value={5}>May</Option>
                  <Option value={6}>June</Option>
                  <Option value={7}>July</Option>
                  <Option value={8}>August</Option>
                  <Option value={9}>September</Option>
                  <Option value={10}>October</Option>
                  <Option value={11}>November</Option>
                  <Option value={12}>December</Option>
                </Select>
              </div>
              <div>
                <DatePicker
                  picker="year"
                  onChange={handleYearChange}
                  defaultValue={dayjs(`${currentYear}`, "YYYY")}
                  placeholder="Select Year"
                  size="large"
                  style={{ width: "100%", borderRadius: 8 }}
                />
              </div>

              <div>
                {/* <button className="btn btn-submit" onClick={handleGeneratePayroll} disabled={loading}>
                  {loading ? (
                    <>
                      <Spin size="small" /> <span>Please wait...</span>
                    </>
                  ) : (
                    "Generate Payslip"
                  )}
                </button> */}
              </div>
            </div>

            {isCustomizing ? (
              <div className="customizer">
                <h2>Customize Fields</h2>

                <div className="fields-list">
                  {fields.map((field, index) => (
                    <div key={field.id} className="field-item">
                      <div className="field-controls">
                        <button onClick={() => moveFieldUp(index)} disabled={index === 0}>
                          ↑
                        </button>
                        <button onClick={() => moveFieldDown(index)} disabled={index === fields.length - 1}>
                          ↓
                        </button>
                      </div>
                      <div className="field-content">
                        <input
                          type="text"
                          value={field.label}
                          onChange={(e) => updateFieldLabel(index, e.target.value)}
                          className="field-label-input"
                        />
                        <input
                          type="text"
                          disabled={true}
                          placeholder="Custom Color"
                          value={field.customClass}
                          onChange={(e) => updateFieldClass(index, e.target.value)}
                          className="field-class-input"
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="employee-data-editor">
                  <h3>Edit Employee Information</h3>
                  <div className="employee-data-fields">
                    {Object.entries(employeeData).map(([key, value]) => (
                      <div key={key} className="employee-data-field">
                        <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                        <input type="text" value={value} onChange={(e) => updateEmployeeData(key, e.target.value)} />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="salary-data-editor">
                  <h3>Edit Salary Information</h3>
                  <div className="salary-data-fields">
                    {Object.entries(salaryData).map(([key, value]) => (
                      <div key={key} className="salary-data-field">
                        <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                        <input
                          type="text"
                          value={value}
                          onChange={(e) => {
                            const newValue =
                              e.target.value === "-"
                                ? "-"
                                : isNaN(Number.parseFloat(e.target.value))
                                  ? e.target.value
                                  : Number.parseFloat(e.target.value)
                            updateSalaryData(key, newValue)
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ) : (
              <div className="salary-slip" ref={payslipRef}>
                {loading ? (
                  <div className="loading-container" style={{ textAlign: "center", padding: "50px" }}>
                    <Spin size="large" />
                    <p>Loading payslip data...</p>
                  </div>
                ) : (
                  <>
                    <div className="salary-slip__header">
                    {/* <h1 className="salary-slip__school-name">{employeeData.name}</h1> */}

                    {/* <h1 className="salary-slip__school-name">{employeeData.account_holder}</h1> */}

                    <h1 className="salary-slip__school-name">
  {employeeData.schoolName || "OKI INTERNATIONAL SCHOOL"}
</h1>                      <h2 className="salary-slip__location">{employeeData.location}</h2>
                      <h3 className="salary-slip__month-title">Salary for the month of {employeeData.month}</h3>
                    </div>

                    <div className="salary-slip__employee-info">
                      <div className="salary-slip__info-row">
                        <div className="salary-slip__info-label">EPF NUMBER</div>
                        <div className="salary-slip__info-value">{employeeData.epf_number}</div>
                      </div>
                      <div className="salary-slip__info-row">
                        <div className="salary-slip__info-label">Branch</div>
                        <div className="salary-slip__info-value">{employeeData.branch}</div>
                      </div>
                      {/* <div className="salary-slip__info-row">
                        <div className="salary-slip__info-label">Email</div>
                        <div className="salary-slip__info-value">{employeeData.email}</div>
                      </div> */}
                      <div className="salary-slip__info-row">
                        <div className="salary-slip__info-label">Name</div>
                        <div className="salary-slip__info-value">{employeeData.name}</div>
                      </div>
                      <div className="salary-slip__info-row">
                        <div className="salary-slip__info-label">ID Number</div>
                        <div className="salary-slip__info-value">{employeeData.nic}</div>
                      </div>
                      <div className="salary-slip__info-row">
                        <div className="salary-slip__info-label">Bank</div>
                        <div className="salary-slip__info-value">{employeeData.bank}</div>
                      </div>
                      <div className="salary-slip__info-row">
                        <div className="salary-slip__info-label">Account No</div>
                        <div className="salary-slip__info-value">{employeeData.account_number}</div>
                      </div>
                    </div>

                    <div className="salary-slip__salary-details">
                      {fields.map((field) => (
                        <div
                          key={field.id}
                          className={`salary-slip__detail-row ${field.id === "netSalary" ? "salary-slip__detail-row--net" : ""} ${field.customClass || ""}`}
                        >
                          <div className="salary-slip__detail-label">{field.label}</div>
                          <div className="salary-slip__detail-value">{formatCurrency(field.value)}</div>
                        </div>
                      ))}
                    </div>

                    <div className="salary-slip__footer"></div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmployeePayslip

